// BNB Address, WMatic Address in Polygon
const BNB_ADDRESS = '0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270'

export { BNB_ADDRESS }
